var parallaxHero = {
    imageContainer: document.querySelectorAll( '.parallax-hero .image-wrap' ),
    scroll: function( event ) {
        // var lowerOffset = window.pageYOffset + window.outerHeight;
        var lowerOffset = window.scrollY + window.outerHeight;
        parallaxHero.imageContainer.forEach( container => {
            if( container.closest( '.parallax-hero' ).offsetTop <= lowerOffset ) {
                container.style.transform = 'translateY( '+ ( ( ( container.closest( '.parallax-hero' ).offsetHeight - container.offsetHeight ) / 2 ) +( ( lowerOffset - container.closest( '.parallax-hero' ).offsetTop ) * 0.3 ) ) + 'px )';
            }
        } );
    },
    init: function() {
        parallaxHero.imageContainer.forEach( container => {
            container.style.transform = 'translateY( '+ ( ( container.closest( '.parallax-hero' ).offsetHeight - container.offsetHeight ) / 2 ) + 'px )';
        } );
        document.addEventListener( 'scroll', parallaxHero.scroll );
    }
};
parallaxHero.init();
